import React from 'react';
import { Link } from 'react-router-dom';

function Hero() {
  return (
    <section className="hero">
      <div className="hero-container">
        <h1>
          Complete Business Manager for <span className="hero-highlight">Saudi Arabia</span>
        </h1>
        <p>
          All-in-one solution for restaurants, cafes, and retail stores. 
          Manage POS, inventory, suppliers, and analytics with VAT compliance built-in.
        </p>
        <div className="hero-buttons">
          <a href="#download" className="btn btn-primary">
            Download Now
          </a>
          <Link to="/pricing" className="btn btn-secondary">
            View Pricing
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Hero;
